import * as React from 'react';
import { InputGroup } from 'react-bootstrap';
import {IControlError, IControlSchema, ValidationResult} from "../../../Controls";
import { Component, I18NString } from "../../../Utils";
import { IDispatcher } from "../../extensions/Dispatcher";
import DateTime from '../../extensions/Datetime';
import { isUndefined, isNull, isEmpty } from 'lodash';
import Field from '../../Field';
import Alert from '../Alert';
import 'moment/locale/ru';

export interface ICalendarSchema extends IControlSchema {
  beginDate: I18NString;
  finishDate: I18NString;
  description: I18NString;
  value?: string;
  disabled?: boolean;
  currentDate: string;
  isMore?: boolean;
  isLess?: boolean;
}

interface Props {
  schema: ICalendarSchema;
  dispatcher?: IDispatcher;
  error: IControlError | undefined;
  visited: boolean;
}

interface State {
  isOpen: boolean,
}


class Calendar extends Component<Props, State>{
    state = {
        isOpen: false
    };

    onChange(date: string, name: string) {
        const validationResult = this.validationResult(date);
        this.props.dispatcher.onBlur(this.props.schema.id, date, !validationResult, validationResult);
    }

    onClick = () => this.setState({ isOpen: !this.state.isOpen });

    componentDidMount() {
        const { schema: { value }, error } = this.props;
        if(!isEmpty(value)) {
            this.props.dispatcher.onVisit(this.props.schema.id);
        }

        if(error) {
            return;
        }
        const validationResult = this.validationResult(value);
        this.props.dispatcher.setError(this.props.schema.id, value, validationResult && { message: validationResult.message }, false);
    }

    validationResult(value: string): ValidationResult {
        return undefined;
    }

    render() {
        const { schema: {disabled, description, value}, error, visited } = this.props;
        const errorText = visited && error && error.message;
        let status = 'default';

        if (errorText)
            status = "error";
        else if (!isEmpty(value))
            status = "success";
        return (
            <Field {...this.props.schema} status={status}
              helpBtn={!isUndefined(this.props.schema.description) ? (<InputGroup.Addon onClick={this.onClick} bsClass="input-group-addon btn btn-default btn-circle">
                <span className="glyphicon glyphicon-question-sign"></span>
              </InputGroup.Addon>) : null}>
                <InputGroup style={{width: "100%"}} id="calendar">
                    <DateTime disabled={disabled}
                        value={value}
                        ignoreTitle
                        onChangeValue={(value: string) => this.onChange(value, 'begin')}
                        onBlur={() => this.props.dispatcher.onVisit(this.props.schema.id)}
                    />
                    {/*{description && (<InputGroup.Addon onClick={this.onClick} bsClass="input-group-addon btn btn-default btn-circle">*/}
                    {/*    <span className="glyphicon glyphicon-question-sign"></span>*/}
                    {/*</InputGroup.Addon>)}*/}
                </InputGroup>
                {description && this.state.isOpen &&
                    (<div className="alert alert-warning" role="alert" dangerouslySetInnerHTML={{ __html: this.tr(description) }} ></div>)}
                {errorText && <Alert>{errorText}</Alert>}
            </Field>
        )
    }
}

export default Calendar;
